import('vite/modulepreload-polyfill');

import './js/sentry.ts';
import './js/posthog.ts';
import './js/tabulator.ts';
import './js/alpine.ts';
import './scss/main.scss';
import './scss/tailwind.css';
import './app';
import './js/pages/Dashboard.ts';
import './js/pages/Portfolio.ts';
import './js/pages/OutlineDetail.ts';
import './js/pages/LayerUpload.ts';
import './js/AudioPlayer.ts';
